export const BASE_URL = 'http://chartdrug.com/v1/api';
//export const BASE_URL = 'http://localhost:8080/v1/api';
